import { Chip } from '../components/ui';

/**
 * The guest viewer's header. A guest has no projects list to go back to, no settings and no
 * account, so the brand is a label rather than a link and the only action is to leave.
 */
export function GuestHeader({ docName, guestName, onLeave, onTour }: { docName: string; guestName: string; onLeave(): void; onTour?: () => void }) {
  return (
    <header className="header">
      <span className="brand"><i />Proofroom</span>
      <nav className="crumbs" aria-label="Breadcrumb">
        <span className="sep">/</span>
        <span>{docName}</span>
      </nav>
      <div className="spacer" />
      {onTour && <button className="btn sm ghost" onClick={onTour}>Show me around</button>}
      <div className="user">
        <span>Guest: {guestName}</span>
        <Chip kind="role">guest</Chip>
        <button className="btn sm ghost" onClick={onLeave}>Leave</button>
      </div>
    </header>
  );
}
